<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 40 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-4 w-4"
  >
    <path
      d="M0.6394 22.0253L1.9496 23.3447C2.362 23.7567 2.9106 23.9837 3.4969 23.9837C4.083 23.9837 4.6322 23.7567 5.0446 23.3447L19.9911 8.3976L34.9548 23.3613C35.3665 23.7733 35.9157 24 36.5018 24C37.0878 24 37.6374 23.7733 38.0494 23.3613L39.36 22.0501C40.2133 21.1974 40.2133 19.8084 39.36 18.9557L21.5439 1.0756C21.1322 0.6639 20.5836 0.3738 19.9924 0.3738H19.9855C19.3992 0.3738 18.8506 0.6642 18.4388 1.0756L0.6394 18.9073C0.227 19.319 0.0007 19.8842 0 20.4702C0 21.0566 0.227 21.614 0.6394 22.0253Z"
      fill="currentColor"
    />
  </svg>
</template>
